import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCreatedAtFilter = createSelector(
  [(store: RootState) => store.supervisorDocumentsList.createdAtFilter],
  (value) => value || { from: 0, to: 0 }
);
